import { useContext } from "react";
import FeatureFlagContextProps from "../../../models/contextModels/featureFlagContext.model";
import { FeatureFlagContext } from "../../../context/FeatureFlaggingContext";

function useFeatureFlags(): FeatureFlagContextProps {
  const context = useContext(FeatureFlagContext);
  if (!context) {
    throw new Error(
      "useFeatureFlags must be used within a FeatureFlagProvider"
    );
  }
  return context;
}

export default useFeatureFlags
